import React, { useCallback, useEffect, useMemo, useRef } from 'react';

import { downloadSettingExcel } from "src/utils/blob/blobUtil";


import { defaultSAL3010_R01Filter, SAL3010_R01Filter, useSAL3010_R01Store } from 'src/containers/mes/SAL/SAL3010_R01/Store_SAL3010_R01';
import useFetchActionbarAuth from 'src/hooks/useFetchActionbarAuth';
import { Tab } from 'src/store/useUiuxStore';
import { useLoadingSpinnerStore } from 'src/store/util/loadingSpinnerUtil';
import { showError, showSuccess, ShowSuccessFetch, showWarning } from 'src/utils/toast/toastUtil';

import { AgGridReact } from 'ag-grid-react';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';
import { fetchDataSetHandler, fetchFilterConfig, gridRefSelectedRowHandler } from 'src/utils/grid/GridHandlerContent';
import { refetchUpdateList } from 'src/utils/axios/reFetch';
import { deleteSAL3010_R01, downloadExcel_SAL3010_R01, getSAL3010_R01AllCount, getSAL3010_R01CreateDetailList, getSAL3010_R01DetailList, getSAL3010_R01List, getSAL3010_R01One, patchSAL3010_R01, postSAL3010_R01 } from "./Api_SAL3010_R01";
import { defaultSAL3010_R01DetailDto, defaultSAL3010_R01HeaderDto, SAL3010_R01DetailDto, SAL3010_R01Dto, SAL3010_R01HeaderDto } from './Dto_SAL3010_R01';
import { formatDateYYYYMMDD, validateString } from 'src/utils/string/stringUtil';
import { validateCustomCd, validateEmployeeCd } from 'src/utils/grid/GridValidateContent';

interface Props {
	gridRef: React.RefObject<AgGridReact<SAL3010_R01HeaderDto> | null>;
	detailGridRef: React.RefObject<AgGridReact<SAL3010_R01DetailDto> | null>;

	tabList: Tab[] | undefined;
	setMessage: (message: string) => void;

	containerRef: React.RefObject<HTMLDivElement | null>;
	isResizing: React.MutableRefObject<boolean>;
	
}



export const Content_SAL3010_R01 = (props: Props) => {

	const {
		gridRef, detailGridRef,
		tabList, setMessage,
		containerRef,
		isResizing,
	} = props;

	const { moneyCdList, vatTypeList, compCdList, customCdList, employeeCdList } = useCommonCodeStore();

	
	const {
		SAL3010_R01Filter, setSAL3010_R01Filter,
		SAL3010_R01PastFilter, setSAL3010_R01PastFilter,
		SAL3010_R01List, setSAL3010_R01List,
		editSAL3010_R01, setEditSAL3010_R01,
		selectedSAL3010_R01, setSelectedSAL3010_R01, 
		deletedSAL3010_R01DetailList, setDeletedSAL3010_R01DetailList, addDeletedSAL3010_R01DetailList, removeDeletedSAL3010_R01DetailList, 
		selectedSAL3010_R01DetailList, setSelectedSAL3010_R01DetailList, addSelectedSAL3010_R01DetailList, removeSelectedSAL3010_R01DetailList,
		SAL3010_R01DetailList, setSAL3010_R01DetailList, insertSAL3010_R01DetailList,
		originalSAL3010_R01DetailList, setOriginalSAL3010_R01DetailList,
		allCount, setAllCount,
		detailFetchTrigger, setDetailFetchTrigger,
		detailCreateTrigger, setDetailCreateTrigger,
		initData,
		setScrollTop, setDetailScrollTop,
	} = useSAL3010_R01Store();
	const { setLoadingSpinner } = useLoadingSpinnerStore();
	const createDetailFetchingRef = useRef(false);

	useFetchActionbarAuth("SAL3010_R01");
	

	const handleExcelClick = useCallback(async () => {
		if (!selectedSAL3010_R01) {
			showWarning("선택된 수금내역내역이 없습니다.");
			return;
		}
		setLoadingSpinner(true);

		const { isDefaultFilter, isDefaultPastFilter, listLength } = fetchFilterConfig(
			SAL3010_R01Filter,
			SAL3010_R01PastFilter,
			defaultSAL3010_R01Filter,
			SAL3010_R01List.length
		);

		const response = await downloadExcel_SAL3010_R01(isDefaultFilter? '' : 'search', selectedSAL3010_R01.collectNo, listLength);

		downloadSettingExcel({ responseData: response.data.data, fileName: '수금내역 등록-excel.xlsx' });

		setLoadingSpinner(false);
	}, [selectedSAL3010_R01])

	const getParams = (filter: SAL3010_R01Filter) => {
		const params: Partial<SAL3010_R01Filter> = {
			paymentDateRange: filter.paymentDateRange || undefined,
			tradeDateRange: filter.tradeDateRange || undefined,
			customCd: filter.customCd || undefined,
			compCd: filter.compCd || undefined,
			compNm: filter.compNm || undefined,
			tradeType: filter.tradeType || undefined,
		};
		return params;
	}

	const renewalAllCount = useCallback(async () => {
		const response = await getSAL3010_R01AllCount(getParams(SAL3010_R01Filter));
		setAllCount(response.data.data);
		return response.data.data;
	}, [SAL3010_R01Filter, setAllCount]);

	const fetchData = useCallback(async () => {
		setScrollTop(null);
		setDetailScrollTop(null);
		setLoadingSpinner(true);		
	
		const responseData = (await getSAL3010_R01List(
			'',
			getParams(SAL3010_R01Filter),
			SAL3010_R01List.length ?? 0
		));


		let newList = [...responseData.data.data] as SAL3010_R01HeaderDto[];
		setSAL3010_R01List(newList);

		const processAllCount = await renewalAllCount();
		if (newList && newList.length > 0) {
			gridRefSelectedRowHandler(
				gridRef,
				setSelectedSAL3010_R01,
				() => true,// () => !responseData.find(value => value.salBillNo === selectedSAL3010_R01?.salBillNo)
			);
			setSAL3010_R01PastFilter(SAL3010_R01Filter);
			ShowSuccessFetch(setMessage, `조회가 완료되었습니다. (총 ${newList.length}/${processAllCount}건)`);
			setTimeout(() => setMessage(""), 5000);
		}else {
			showWarning('데이터가 없습니다.');
			setSelectedSAL3010_R01(undefined);
			setSAL3010_R01List([]);
			setSAL3010_R01DetailList([]); 
			setDeletedSAL3010_R01DetailList([]);
			setSelectedSAL3010_R01DetailList([]);
			setOriginalSAL3010_R01DetailList([]);
		}
		setLoadingSpinner(false);
		return responseData;
	}, [SAL3010_R01Filter, SAL3010_R01List, setSAL3010_R01List, setSAL3010_R01PastFilter, setSelectedSAL3010_R01, selectedSAL3010_R01, setScrollTop, setDetailScrollTop])

	const defaultSAL3010_R01HeaderRow = useCallback(() => {
		return {
			...defaultSAL3010_R01HeaderDto,
			compCd: compCdList[0].compCd,
			moneyCd: moneyCdList[0].minorCd,
			inserted: true,
		}
	}, [defaultSAL3010_R01HeaderDto, compCdList]);

	const defaultSAL3010_R01DetailRow = useCallback(() => {
		return {
			...defaultSAL3010_R01DetailDto,
			inserted: true,
		}
	}, [defaultSAL3010_R01DetailDto, compCdList, ]);
	
	const initContainerData = useCallback(() => {
		initData();
		removeDeletedSAL3010_R01DetailList();
		removeSelectedSAL3010_R01DetailList();
		setEditSAL3010_R01({ ...defaultSAL3010_R01HeaderRow(), })
	}, [defaultSAL3010_R01HeaderRow, selectedSAL3010_R01])

	const handleCreateClick = useCallback(() => {
		setDetailCreateTrigger(false);
		setSelectedSAL3010_R01(undefined);
		setEditSAL3010_R01({ ...defaultSAL3010_R01HeaderRow(), })
		setSAL3010_R01DetailList([]);
		setDeletedSAL3010_R01DetailList([]);
		setSelectedSAL3010_R01DetailList([]);
		setOriginalSAL3010_R01DetailList([]);
		setDetailScrollTop(null);
	}, [
		defaultSAL3010_R01HeaderRow,
		setDetailCreateTrigger,
		setSelectedSAL3010_R01,
		setEditSAL3010_R01,
		setSAL3010_R01DetailList,
		setDeletedSAL3010_R01DetailList,
		setSelectedSAL3010_R01DetailList,
		setOriginalSAL3010_R01DetailList,
		setDetailScrollTop,
	]);

	const handleDeleteClick = useCallback(async () => {
		if (!selectedSAL3010_R01) {
			showWarning('선택된 수금내역이 없습니다.');
			return;
		}

		if (!window.confirm('정말로 삭제하시겠습니까?')) {
			return;
		}

		await deleteSAL3010_R01(selectedSAL3010_R01.collectNo);
		refetchUpdateList('delete', defaultSAL3010_R01HeaderRow(), selectedSAL3010_R01, 'tradeNo', SAL3010_R01List, setSAL3010_R01List);
		handleCreateClick();
		showSuccess(`${selectedSAL3010_R01.tradeNo || selectedSAL3010_R01.collectNo} 수금내역 삭제가 완료되었습니다.`);
	}, [
		selectedSAL3010_R01,
		defaultSAL3010_R01HeaderRow,
		SAL3010_R01List,
		setSAL3010_R01List,
		handleCreateClick,
	]);

	const validateInsertData = (header: SAL3010_R01HeaderDto, detailList: SAL3010_R01DetailDto[]) => {
		
		if (!validateString(header.compCd)) {
			showWarning('사업장을 선택해주세요.'); return false;
		}
		if (!validateString(header.customCd)) {
			showWarning('거래처를 입력해주세요.'); return false;
		}
		if (!validateCustomCd(header.customCd, customCdList)) {
			showWarning('거래처가 존재하지 않습니다.(입력칸을 더블클릭하거나 엔터키로 세부사항을 열어서 지정해주세요)'); return false;
		}
		if(!validateString(header.empNo)) {
			showWarning('담당자를 선택해주세요.'); return false;
		}
		if (!validateEmployeeCd(header.empNo, employeeCdList)) {
			showWarning('담당자가 존재하지 않습니다.(입력칸을 더블클릭하거나 엔터키로 세부사항을 열어서 지정해주세요)'); return false;
		}

		if (Number(header.noteAmt ?? 0) > 0) {
			const issueDate = formatDateYYYYMMDD(header.issueDt);
			const dueDate = formatDateYYYYMMDD(header.dueDt);
			if (!issueDate || !dueDate) {
				showWarning('어음금액이 있을 경우 발행일과 만기일을 입력해주세요.'); return false;
			}
			if (dueDate < issueDate) {
				showWarning('어음만기일은 어음발행일보다 같거나 커야 합니다.'); return false;
			}
		}

		// if (!validateString(header.tradeNo)) {
		// 	const deletedDetailIndexList = deletedSAL3010_R01DetailList.map(value => Number(value));
		// 	const checkedDetailCount = detailList.filter(
		// 		detail => !deletedDetailIndexList.includes(detail.valueIndex) && detail.checkProcess === 'Y',
		// 	).length;
		// 	if (checkedDetailCount <= 0) {
		// 		showWarning('처리할 상세내역을 선택해주세요.'); return false;
		// 	}

		// 	const activeDetailList = filterDeletedItems(detailList, deletedSAL3010_R01DetailList);

		// 	for (const detail of activeDetailList) {
		// 		if (!validateString(detail.itemNo)) continue;

		// 		const otherDetailList = activeDetailList.filter(d =>
		// 			(detail.valueIndex != null && d.valueIndex !== detail.valueIndex) ||
		// 			(detail.valueIndex == null && d !== detail)
		// 		);
		// 		if (otherDetailList.some(d => d.itemNo === detail.itemNo)) {
		// 			showWarning("중복된 항목번호가 있습니다.\n항목번호: " + detail.itemNo);
		// 			return false;
		// 		}
		// 	}
		// }

		return true;
	}

	const setInfoDetailList = useCallback((header: SAL3010_R01HeaderDto, detailList: SAL3010_R01DetailDto[]) => {
		
		return detailList.map((value, idx) => ({
			...value,
			compCd: header.compCd,
			customCd: header.customCd,
		}))
	}, [setSAL3010_R01DetailList])
	
	const handleSaveClick = useCallback(async () => {

		let valid = true;
		if(!validateInsertData(editSAL3010_R01!, SAL3010_R01DetailList)) valid = false;
		if(!valid) { return; }
		
		const deletedSAL3010_R01DetailList_Number = deletedSAL3010_R01DetailList.map(value => Number(value));
		let processName = '';
		let newDetailList: SAL3010_R01DetailDto[] = [];
		let newHeaderList: SAL3010_R01HeaderDto[] = [];
		let responseData: SAL3010_R01Dto = {
			salesCollectHeaderDto: editSAL3010_R01!,
			salesCollectDetailDtoList: SAL3010_R01DetailList
		};

		if (selectedSAL3010_R01) {
			newDetailList = SAL3010_R01DetailList.filter(value => 
				!deletedSAL3010_R01DetailList_Number.includes(value.valueIndex)
			);

			processName = 'patch';
			const patchResponse = await patchSAL3010_R01({
				salesCollectHeaderDto: editSAL3010_R01!,
				salesCollectDetailDtoList: setInfoDetailList(editSAL3010_R01!, newDetailList)
			});

			responseData = patchResponse.data.data[0];
			newHeaderList = SAL3010_R01List.map(value => {
				if (value.tradeNo === responseData.salesCollectHeaderDto.tradeNo) {
					return responseData.salesCollectHeaderDto;
				}
				return value;
			});
			
			if (patchResponse?.data?.data?.[0] && patchResponse.data.successFlag) {

				showSuccess('수금내역 수정에 성공하였습니다.');
				setMessage('수금내역 수정에 성공하였습니다.');
			}else {
				// 서버 응답이 예상과 다를 경우의 에러 처리
				showWarning('수금내역 수정 후 서버로부터 올바른 데이터를 받지 못했습니다.');
				return;
			}
		} else {
			processName = 'post';
			const activeDetailList = SAL3010_R01DetailList.filter(value =>
				!deletedSAL3010_R01DetailList_Number.includes(value.valueIndex) && value.checkProcess === 'Y',
			);
			const postResponse = await postSAL3010_R01({
				salesCollectHeaderDto: editSAL3010_R01!,
				salesCollectDetailDtoList: setInfoDetailList(editSAL3010_R01!, activeDetailList),
			});

			responseData = postResponse.data.data[0];
			newHeaderList = [
				...SAL3010_R01List,
				responseData.salesCollectHeaderDto,
			] as SAL3010_R01HeaderDto[];

			if (postResponse?.data?.data?.[0] && postResponse.data.successFlag) {
				showSuccess('수금내역 등록에 성공하였습니다.');
				setMessage('수금내역 등록에 성공하였습니다.');
			} else {
				showWarning('수금내역 등록 후 서버로부터 올바른 데이터를 받지 못했습니다.');
				return;
			}
		}


		if (processName === 'delete') {
			setSAL3010_R01List(newHeaderList);
			setSelectedSAL3010_R01(undefined);
			setSAL3010_R01DetailList([]);
			handleCreateClick();
		}else if (processName === 'patch' || processName === 'post') {
			setSAL3010_R01List(newHeaderList);
			setSAL3010_R01DetailList(responseData.salesCollectDetailDtoList);
			
			setSelectedSAL3010_R01(responseData.salesCollectHeaderDto);
			setOriginalSAL3010_R01DetailList(responseData.salesCollectDetailDtoList);
		}

		// setSelectedSAL3010_R01(undefined);
		setDeletedSAL3010_R01DetailList([]);
		setSelectedSAL3010_R01DetailList([]); // 저장 후 상세행 선택 상태 초기화
		setTimeout(() => {
			setMessage('');
		}, 5000)
	
	}, [
		editSAL3010_R01, 
		selectedSAL3010_R01, 
		SAL3010_R01DetailList, 
		deletedSAL3010_R01DetailList, 
		SAL3010_R01List, setSAL3010_R01List
	])

	const fetchOne = useCallback(async () => {
		if (!selectedSAL3010_R01?.tradeNo) return;
		setLoadingSpinner(true);
		try {
			const response = await getSAL3010_R01One(selectedSAL3010_R01.tradeNo);
			setEditSAL3010_R01(response.data.data as SAL3010_R01HeaderDto);
		} catch (error) {
			console.error("조회 중 오류 발생:", error);
			showError("조회 중 오류가 발생했습니다.");
		}
		setLoadingSpinner(false);
	}, [selectedSAL3010_R01, setEditSAL3010_R01, setLoadingSpinner]);

	const fetchDetailList = useCallback(async (tradeNo: string) => {
		if (!detailFetchTrigger) return;
		setDetailScrollTop(null);

		(detailGridRef.current as any)?.clearRange?.();

		const responseData = (await getSAL3010_R01DetailList(tradeNo)).data.data;
		if(responseData && responseData.length > 0){
			setSAL3010_R01DetailList(responseData.map((value, idx) => ({
				...value,
				valueIndex: value.valueIndex ?? idx + 1,
				orderIndex: value.orderIndex ?? idx + 1,
				orderIndexSeq: value.orderIndexSeq ?? 0,
			})));
			setOriginalSAL3010_R01DetailList(responseData);
			setMessage(`${selectedSAL3010_R01?.customNm}의 수금내역내역 ${responseData.length}건을 조회하였습니다.`);
			setTimeout(() => setMessage(""), 5000);
		}else{
			showError('상세내역이 없습니다.');
			setSAL3010_R01DetailList([]);
			insertSAL3010_R01DetailList([{ ...defaultSAL3010_R01DetailRow() }])
		}
		setDetailFetchTrigger(false);
	}, [
		detailFetchTrigger,
		setDetailScrollTop,
		detailGridRef,
		setSAL3010_R01DetailList,
		setOriginalSAL3010_R01DetailList,
		selectedSAL3010_R01?.customNm,
		setMessage,
		insertSAL3010_R01DetailList,
		defaultSAL3010_R01DetailRow,
		setDetailFetchTrigger,
	])

	const fetchCreateDetailList = useCallback(async (customCd: string) => {
		const { detailCreateTrigger } = useSAL3010_R01Store.getState();
		if (!detailCreateTrigger || !customCd || createDetailFetchingRef.current) return;

		createDetailFetchingRef.current = true;
		setDetailCreateTrigger(false);
		setDetailScrollTop(null);

		(detailGridRef.current as any)?.clearRange?.();

		try {
			const responseData = (await getSAL3010_R01CreateDetailList(customCd, SAL3010_R01Filter.tradeDateRange)).data.data;
			if(responseData && responseData.length > 0){
				setSAL3010_R01DetailList(responseData.map((value, idx) => ({
					...value,
					valueIndex: value.valueIndex ?? idx + 1,
					orderIndex: value.orderIndex ?? idx + 1,
					orderIndexSeq: value.orderIndexSeq ?? 0,
					inserted: true,
				})));
				setOriginalSAL3010_R01DetailList([]);
				setMessage(`등록용 수금내역 ${responseData.length}건을 조회하였습니다.`);
				setTimeout(() => setMessage(""), 5000);
			}else{
				showError('등록용 수금내역을 찾을 수 없습니다');
				setSAL3010_R01DetailList([]);
			}
		} finally {
			createDetailFetchingRef.current = false;
			setDetailCreateTrigger(false);
		}
	}, [
		SAL3010_R01Filter.tradeDateRange,
		setDetailScrollTop,
		detailGridRef,
		setSAL3010_R01DetailList,
		setOriginalSAL3010_R01DetailList,
		setMessage,
		insertSAL3010_R01DetailList,
		defaultSAL3010_R01DetailRow,
		setDetailCreateTrigger,
	])

	useEffect(() => {
		if (detailCreateTrigger && editSAL3010_R01?.customCd) {
			fetchCreateDetailList(editSAL3010_R01.customCd);
		}
	}, [detailCreateTrigger, editSAL3010_R01?.customCd, fetchCreateDetailList])

	useEffect(() => {
		if (selectedSAL3010_R01) {
			fetchOne();
			// fetchDetailList(selectedSAL3010_R01.tradeNo!)
		}
	}, [selectedSAL3010_R01, fetchOne, fetchDetailList])
	
	return {
		handleExcelClick,
		fetchData,
		defaultSAL3010_R01HeaderRow,
		defaultSAL3010_R01DetailRow,
		initContainerData,
		handleDeleteClick,
		handleCreateClick,
		handleSaveClick,
	};
}
